/* @flow */

const isLoggi = (): boolean => {
    const loggi = document.getElementById('loggi-atendimento');
    return loggi instanceof HTMLInputElement && loggi.checked;
};

export default isLoggi;
